import moment from 'moment-timezone'

export const CALIFORNIA_TZ = 'America/Los_Angeles'

export function getCaliforniaTodayFormatted() {
  return moment.tz(CALIFORNIA_TZ).format('YYYY-MM-DD')
}

export function getCaliforniaTodayStart() {
  return moment.tz(CALIFORNIA_TZ).startOf('day')
}

export function getAssignmentDateFormatted(assignmentDate) {
  return moment.utc(assignmentDate).format('YYYY-MM-DD')
}

export function isAssignmentOnOrAfterCaliforniaToday(assignmentDate) {
  return (
    getAssignmentDateFormatted(assignmentDate) >= getCaliforniaTodayFormatted()
  )
}

export function isDateBeforeCaliforniaToday(date) {
  return moment(date).startOf('day').isBefore(getCaliforniaTodayStart(), 'day')
}

export function filterAssignmentsFromToday(housemates) {
  if (!housemates) return []
  return housemates.filter(([assignment]) =>
    isAssignmentOnOrAfterCaliforniaToday(assignment.date)
  )
}

export function filterChoresWithUpcomingAssignments(chores) {
  return (chores || [])
    .map((chore) => ({
      ...chore,
      housemates: filterAssignmentsFromToday(chore.housemates)
    }))
    .filter((chore) => chore.housemates.length > 0)
}
